(function () {
    const product_slider_v1_list = document.querySelectorAll(
        ".js_product_slider_v1"
    );
    for (let i = 0; i < product_slider_v1_list.length; i++) {
        const slider = product_slider_v1_list[i];
        initProductSliderV1(slider);

        handleEqualHeightOnContentElements(slider);
    }

    function initProductSliderV1(slider) {
        const sliderWrapEl = slider.closest(".product-slider-sec");
        const swiperPagination =
            sliderWrapEl.querySelector(".swiper-pagination");
        const swiperButtonNext = sliderWrapEl.querySelector(
            ".swiper-button-next"
        );
        const swiperButtonPrev = sliderWrapEl.querySelector(
            ".swiper-button-prev"
        );

        let sliderOptions = {
            spaceBetween: 40,
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 992px
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
            pagination: {
                el: swiperPagination,
                clickable: true,
                dynamicBullets: false,
            },
            navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
            },
        };

        new Swiper(slider, sliderOptions);
    }

    function handleEqualHeightOnContentElements(slider) {
        const _contents = slider.querySelectorAll(".slide-card__footer .inner");
        if (window.innerWidth > 992) {
            setEqualHeightOnContentElements(_contents);

            window.addEventListener("resize", () =>
                handleEqualHeightOnContentElements(slider)
            );
        } else {
            _contents.forEach((content) => {
                content.children[0].style.height = "initial";
                content.children[1].style.height = "initial";
            });
        }
    }

    function setEqualHeightOnContentElements(contents) {
        if (contents) {
            let _titleMaxHeight = 0;
            let _textMaxHeight = 0;

            contents.forEach((content) => {
                content.children[1].style.height = ""; // Reset the height before calculating

                _titleMaxHeight = getElementMaxHeight(
                    content.children[0].children[0],
                    _titleMaxHeight
                );
                _textMaxHeight = getElementMaxHeight(
                    content.children[1].children[0],
                    _textMaxHeight
                );
            });

            contents.forEach((content) => {
                content.children[0].style.height = _titleMaxHeight + "px";
                content.children[1].style.height = _textMaxHeight + "px";
            });
        }
    }

    function getElementMaxHeight(el, elMaxHeight) {
        if (el.offsetHeight > elMaxHeight) {
            elMaxHeight = el.offsetHeight;
        }

        return elMaxHeight;
    }
})();
